Custom Vue-Formulate field for international Phone Number input
Based on libphonenumber-js
Intended to be used like any other Vue-Formulate input formulate-input 
key point here is to update context.model with the real value you want -- that's what vue-formulate uses for everything

<template>
    <div
        :class="`formulate-input-element formulate-input-element--${context.type}`"
        :data-type="context.type"
    >
        <input
            type="tel"
            :value="localValue"
            v-bind="context.attributes"
            @input="updateModel($event.target.value, countryCode)"
            @blur="context.blurHandler"
        >
        
        <!-- <p class="mb-0">isValid? {{isPhoneNumberValid}}</p>
        <p class="mb-0">The Number: {{theNumber}}</p>
        <p class="mb-0">International Format: {{formattedInternational}}</p>
        <p class="mb-0">National Format: {{formattedNational}}</p>
        <p class="mb-0">URI: {{formattedURI}}</p> -->
    </div>
</template>

<script>

//import parsePhoneNumber from 'libphonenumber-js/min';
import { parsePhoneNumberFromString, AsYouType } from 'libphonenumber-js/min';

export default {
    name: 'FormulatePhoneNumber',
    components: {},
    props: {
        context: {  // the vue-formulate context object
            type: Object,
            required: true,
        },
        countryCode: {  // 2 digit country code if known
            type: String,
            default: '',
        },
        /* value: {  // v-model with parent -- the phone number in E164 format
            type: String,
            default: '',
        },
        name: {  // name that gets passed directly to 'name' prop of formulate-input
            type: String,
            required: true,
        }, 
        label: {  // passed directly to formulate-input
            type: String,
            default: "Phone Number",
        },
        placeholder: {  // passed directly to formulate-input
            type: String,
            default: "Phone number"
        },
        required: {  // Boolean, adds 'required' to validation prop of formulate-input
            type: Boolean,
            default: false,
        } */
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            localValue: this.context.model || '',  // set with initial value passed in (context.value) but don't make it binding, so don't set to context.model
        }
    },
    computed: {
        parsedPhoneNumber: function() {
            return parsePhoneNumberFromString(this.localValue, this.countryCode);
        },
        isPhoneNumberValid: function() {  // returns Boolean
            if (!this.parsedPhoneNumber) return false;
            return this.parsedPhoneNumber.isValid();
        },
        theNumber: function() {  // returns String
            if (!this.parsedPhoneNumber) return '';
            return this.parsedPhoneNumber.number;  // this is the number with plus, without spaces, in format to save to DB:  '+14084218888'
        },
        formattedInternational: function() {  // returns String
            if (!this.parsedPhoneNumber) return '';
            return this.parsedPhoneNumber.formatInternational();  // formatted for display, not for saving to DB:  +1 408 421 8888
        },
        formattedNational: function() {  // returns String
            if (!this.parsedPhoneNumber) return '';
            return this.parsedPhoneNumber.formatNational();  // formatted for local/national use:  (408) 421-8888
        },
        formattedURI: function() {  // returns String
            if (!this.parsedPhoneNumber) return '';
            return this.parsedPhoneNumber.getURI();  // formatted for use in URI:  tel:+14084218888
        }
    },
    watch: {
        countryCode: function(countryCodeValue) {
            this.updateModel(this.localValue, countryCodeValue);  // there are 2 inputs that go into setting context.model (localValue and countryCode) -- this one triggers update method based on changes to countryCode
        }
    },
    methods: {
        handleError: function(error, message) {
            console.log(message);
            console.log(error);
            this.errorMsg = message;
            this.error = true;
        },
        updateModel: function(localValue, countryCode) {  // you pass in this.localValue, quickly update it with AsYouType, then set it again
            const asYouType = new AsYouType(countryCode);  // AsYouType() is a formatter instance... has bunch of class methods
            let currentFormattedValue = asYouType.input(localValue);  // update the instance with the latest input, this will return the formatted value based on current input, like '(408) 421'
            this.localValue = currentFormattedValue;  // set this to make the v-model so it displays the currently formatted value
            let asYouTypePhoneNumberObj = asYouType.getNumber();  // returns the PhoneNumber object, parsed from value as we type
            //let theNumber = asYouTypePhoneNumberObj ? asYouTypePhoneNumberObj.number : '';  // the E164 formatted number:  '+14084218888'
            
            //let phoneNumber = parsePhoneNumberFromString(localValue, this.countryCode);
            if (asYouTypePhoneNumberObj && asYouTypePhoneNumberObj.isValid()) {
                this.context.model = asYouTypePhoneNumberObj.number;  // this is the key -- set context.model to the correct format phone number, but only if its valid
            } else {
                this.context.model = '';  // need to do this... otherwise OLD context.model value will stay there until we have a new VALID one (only valid)
            }
        },
        // add custom validation methods using libphonenumber-js

    }
}
</script>

<style>


</style>